import { render, staticRenderFns } from "./add-people-form.vue?vue&type=template&id=0aa629a8&"
import script from "./add-people-form.vue?vue&type=script&lang=ts&"
export * from "./add-people-form.vue?vue&type=script&lang=ts&"
import style0 from "./add-people-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports